import { memo } from 'react';

function createToolbarComponent(type, component) {
  var _component$displayNam;
  component.displayName = (_component$displayNam = component.displayName) != null ? _component$displayNam : `ToolbarComponent.${type}`;
  return assignTypeProperty(type, /*#__PURE__*/memo(component));
}
function assignTypeProperty(type, component) {
  component.pluginType = type;
  return component;
}

export { createToolbarComponent };
